<app-header></app-header>

<div class="plans-prices-container">
  <div class="plans-prices-titles">
    <h1 class="plans-prince-title">Planes y Precios</h1>
    <p class="plans-prices-desc">
      Elige el plan que más se ajuste a tu necesidad, hay variedad de opciones
      con diferentes funcionalidades y por supuesto con precios muy
      competitivos.
    </p>
    <div class="type-plans">
      <button
        type="button"
        class="btn btn-outline-danger app-light-blue-button auth-button marketplace"
        (click)="changePlan('marketplace')"
      >
        <p>Marketplace</p>
        <!-- <div class="arrow-down"></div> -->
      </button>
      <button
        type="button"
        class="btn btn-outline-danger app-light-blue-button auth-button marketplace"
        (click)="changePlan('feria')"
      >
        <p style="line-height: 0.8rem;">Feria de negocios</p>
        <!-- <div class="arrow-down"></div> -->
      </button>
      <button
        type="button"
        class="btn btn-outline-danger app-light-blue-button auth-button marketplace"
        (click)="changePlan('feriaescolar')"
      >
        <p>Feria escolar</p>
        <!-- <div class="arrow-down"></div> -->
      </button>
    </div>
  </div>
</div>

<div class="row cards">
  <div class="col-md-6 col-sm-12" class="cards-ajust" *ngFor="let p of planes">
    <mat-card class="card-prices card">
      <div class="superior-line" [ngStyle]="{ background: p.color_plan }"></div>
      <h5 class="plan-name">{{ p.nombre_plan }}</h5>
      <mat-card-title
        class="plan-1-price"
        *ngIf="p.precio_plan !== 'Contáctanos'"
      >
        COP {{ parseAmount(p.precio_plan) + '.00' || 'Free' }}
      </mat-card-title>

      <mat-card-title
        class="plan-1-price"
        *ngIf="p.precio_plan === 'Contáctanos'"
      >
        {{ p.precio_plan }}
      </mat-card-title>
      <mat-card-content class="txt-caracteristicas">
        <p *ngFor="let c of p.carateristicas_plan">
          <fa-icon [icon]="c.icon" [style]="c.color"></fa-icon>
          {{ c.nombre }}
          <span *ngIf="c.valor != 'Si' && c.valor != 'No'">
            : {{ c.valor }}
          </span>
        </p>
      </mat-card-content>
      <mat-card-actions>
        <button
          *ngIf="p.nombre_plan == 'Premium'"
          mat-button
          class="btn btn-plan-1"
          (click)="contact()"
        >
          Contactar
        </button>
        <button
          *ngIf="p.nombre_plan == 'Demo'"
          mat-button
          class="btn btn-plan-1"
          (click)="getDemo(p.cantidad_de_asistentes)"
        >
          Adquirir demo
        </button>
        <button
          *ngIf="p.nombre_plan != 'Demo' && p.nombre_plan != 'Premium'"
          mat-button
          class="btn btn-plan-1"
          (click)="
            goToPayment(
              p.nombre_plan,
              p.precio_plan,
              p.dias_disponible,
              p.cantidad_de_asistentes
            )
          "
        >
          Comprar plan
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>

<app-footer></app-footer>
